import { Dictionary, IBaseRUMManager, IBaseRUMStrategy, IRUMUserDataProvider, RUMEventData } from '@nab/x-types';
/**
 * [[include:packages/consumer/sdk-core/src/RUMManager/README.md]]
 */

class BaseRUMManager<E = RUMEventData> implements IBaseRUMManager<any> {
    private rumStrategy: IBaseRUMStrategy<E>;

    protected userDataProviders: Dictionary<IRUMUserDataProvider> = {};

    /**
     * @param {IBaseRUMStrategy} strategy Initialize the RUM Manager to use the specific RUM strategy that will help capture the data from the manager to required Real User Monitoring purposes.
     */
    constructor(strategy: IBaseRUMStrategy<E>) {
        if (!strategy) {
            // eslint-disable-next-line no-console
            console.warn('Missing RUM Strategy, please initialise one and pass through.');
        }
        this.rumStrategy = strategy;
    }

    /**
     * Used to report the event based on the pre-defined strategy
     * @param appId the miniapps appId, this is used to get the defined User Data provider.
     * @param eventData RUM Event data, the event you are trying to fire.
     */
    public emitEvent(appId: string, eventData: E): void {
        if (!this.rumStrategy) {
            // eslint-disable-next-line no-console
            console.warn('RUM Strategy is not specified');
        } else {
            return this.rumStrategy.emitEvent(eventData, this.userDataProviders[appId]);
        }
    }

    /**
     * Used to set the user data provider
     * @param userDataProvider RUM user data provider, the RUM user data provider allows miniapps to set the kind of information they would like to be tracked when firing events to AppD Rum.
     */
    public setUserDataProvider(appId: string, userDataProvider: IRUMUserDataProvider) {
        this.userDataProviders[appId] = userDataProvider;
    }
}

export { BaseRUMManager };
